{
  "id": "campaign-031",
  "name": "Merry Green",
  "seed": "campaign:31",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...b._......",
    "....s_s.b...",
    "....s_s~....",
    "....._~~~...",
    ".x..._.~.b..",
    "...l._..T...",
    "....._......",
    "....._......",
    "....._......",
    "....._.b....",
    "..q.._......",
    "....._......",
    "....l_......",
    "....._.....T",
    "....._...*..",
    "........*.*.",
    "S........*.."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 7
    }
  ],
  "generatorVersion": 3,
  "level": 31,
  "biome": "park",
  "par": {
    "reel": 6405,
    "push": 5564,
    "selfPropelled": 5196,
    "tractor": 4960,
    "zeroTurn": 3597,
    "fairway": 2090
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 22,
      "selfPropelled": 15,
      "tractor": 10,
      "zeroTurn": 0,
      "fairway": 23
    }
  }
}
